import script from "./Task.vue?vue&type=script&lang=ts&setup=true"
export * from "./Task.vue?vue&type=script&lang=ts&setup=true"

import "./Task.vue?vue&type=style&index=0&id=b86eb76a&lang=less"

const __exports__ = script;

export default __exports__